export const ROUTE = {
  LOGIN: '/',
  REGISTER: '/shareRegister',
  SALE_CARD: '/sale-card',
  NEW_USER: '/new-user',
  ONBOARDING: '/onboarding',
  SERVICE: '/service',
  PRIVACY: '/police',
  CONTRACT: '/contract',
  VIDEO_PLAY: '/video-play',
  HOME: '/home',
  ATTEND: '/attend',
  ENROLLED: '/enrolled',
  COMPLETED: '/completed',
  ADDRESS: '/address',
  VIDEO: '/video',
  HOMEWORK: '/homework',
  CLASS_DETAIL: '/class-detail',
  PROFILE: '/profile',
  ADD_CHILDREN: '/add-children',
  TRANSACTION: '/transaction',
  MEMBERSHIP: '/membership',
  CHANGE_PLAN: '/change-plan',
  STATEMENT: '/statement'
}



// WEBPACK FOOTER //
// ./src/router/paths.js